export function buildChartTimeline({ candles, millisBetweenCandles }) {
  if (!Array.isArray(candles) || candles.length === 0) {
    return {
      candles: [],
      gaps: [],
      timeStampArray: [],
      totalSlots: 0,
    };
  }

  const sortedCandles = [...candles].sort(
    (left, right) => Number(left.timeStamp) - Number(right.timeStamp)
  );

  const gaps = [];
  const timeStampArray = [];
  let slotIndex = 0;
  let previousTimeStamp = null;

  const candlesWithSlots = sortedCandles.map((candle) => {
    const currentTimeStamp = Number(candle.timeStamp);

    if (previousTimeStamp === null || !millisBetweenCandles) {
      timeStampArray.push(currentTimeStamp);
    } else {
      const missingSlots = Math.max(
        Math.round((currentTimeStamp - previousTimeStamp) / millisBetweenCandles) - 1,
        0
      );

      if (missingSlots > 1) {
        const gapSlotIndex = slotIndex;
        // The visual slot is a compressed market-closure gap, not a candle. A fabricated
        // midpoint timestamp made the x-axis display labels such as "00:45" between yesterday's
        // close and today's open, making otherwise-correct intraday charts look corrupted.
        timeStampArray.push(null);
        gaps.push({
          slotIndex: gapSlotIndex,
          startTimeStamp: previousTimeStamp,
          endTimeStamp: currentTimeStamp,
          missingSlots,
        });
        slotIndex += 1;
      }

      timeStampArray.push(currentTimeStamp);
    }

    const candleWithSlot = {
      ...candle,
      slotIndex,
    };

    slotIndex += 1;
    previousTimeStamp = currentTimeStamp;
    return candleWithSlot;
  });

  return {
    candles: candlesWithSlots,
    gaps,
    timeStampArray,
    totalSlots: timeStampArray.length,
  };
}
